import { createSlice } from "@reduxjs/toolkit";

export const ShowHistoryTabModalSlice = createSlice({
    name: "showHistoryTabModal",
    initialState: {
        showHistoryTabModal: false,
        historyTabEstateId: null,   // which estate's history to show
    },
    reducers: {
        setShowHistoryTabModal: (state, action) => {
            // action.payload can be:
            //   true/false (legacy boolean — just toggles visibility)
            //   { show: true, estateId: 6521728 } (new form — sets both)
            if (typeof action.payload === "object" && action.payload !== null) {
                state.showHistoryTabModal = action.payload.show;
                state.historyTabEstateId  = action.payload.estateId ?? null;
            } else {
                state.showHistoryTabModal = action.payload;
                if (!action.payload) {
                    state.historyTabEstateId = null; // clear on close
                }
            }
        }
    }
})

export const { setShowHistoryTabModal } = ShowHistoryTabModalSlice.actions;

export default ShowHistoryTabModalSlice.reducer;
